/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
import React from "react";

interface HeaderProps {
  body: string;
}

const AllMicrosoftAction = ".c-button-logo.all-ms-nav";
const OpenInNewTab = "_blank";
const UHFHeaderLinksClassName = "c-uhf-nav-link";

export const UHFTopHeader: React.FC<HeaderProps> = ({ body }) => {
  let headerHTML = { __html: body };
  React.useEffect(() => {
    headerHTML = { __html: body };
    //eslint-disable-next-line
    const allMs: any = document.querySelectorAll(AllMicrosoftAction);
    if (allMs && allMs.length !== 0) {
      allMs[0].style.display = "none";
    }
    const headerAnchorElements = document.getElementsByClassName(
      UHFHeaderLinksClassName
    );
    for (let i = 0; i < headerAnchorElements.length; i++) {
      headerAnchorElements[i].addEventListener("click", universalHeaderEvent);
    }

    const skipTOMain = document?.getElementById("uhfSkipToMain");
    if (skipTOMain) {
      skipTOMain.setAttribute("data-href", "#appaction");
      skipTOMain.addEventListener("click", moveTOAppaction);
    }

    function moveTOAppaction() {
      if (skipTOMain) skipTOMain.blur();
      document.getElementById("appaction")?.scrollIntoView();
      const notificationButton = document.querySelector(
        '[title="Notifications"]'
      ) as HTMLElement;
      notificationButton?.focus();
    }
    return () => {
      skipTOMain?.removeEventListener("click", moveTOAppaction);
    };
  }, [body]);


  //eslint-disable-next-line
  function universalHeaderEvent(sender: any) {
    sender.preventDefault();
    const anchorLink = sender.target.getAttribute("href");
    window.open(anchorLink, OpenInNewTab);
  }

  return <div role="banner" dangerouslySetInnerHTML={headerHTML}></div>;
};
